import { render, staticRenderFns } from "./TenantHeieihubSetting.vue?vue&type=template&id=0220d52a"
import script from "./TenantHeieihubSetting.vue?vue&type=script&lang=js"
export * from "./TenantHeieihubSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports